(() => {
  const DESKTOP_MQ = '(min-width: 990px)';

  function lockFaqImageMedia(section) {
    if (!section || section.dataset.faqImageMediaLocked === 'true') return;

    const layout = section.querySelector('.faq-image__layout');
    const media = layout?.querySelector('.faq-image__media');
    if (!layout || !media) return;

    section.dataset.faqImageMediaLocked = 'true';

    let ratio = null;
    const mq = window.matchMedia(DESKTOP_MQ);
    let frame = 0;

    const apply = () => {
      if (!mq.matches) {
        media.style.height = '';
        media.classList.remove('is-height-locked');
        ratio = null;
        return;
      }

      if (ratio == null) {
        media.style.height = '';
        media.classList.remove('is-height-locked');
        const rect = media.getBoundingClientRect();
        if (rect.width < 1 || rect.height < 1) return;
        ratio = rect.height / rect.width;
      }

      media.style.height = `${media.getBoundingClientRect().width * ratio}px`;
      media.classList.add('is-height-locked');
    };

    const schedule = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        requestAnimationFrame(apply);
      });
    };

    if (document.fonts?.ready) {
      document.fonts.ready.then(schedule);
    }

    mq.addEventListener('change', () => {
      ratio = null;
      schedule();
    });
    window.addEventListener('resize', schedule);
    schedule();
  }

  function initFaqImageMediaLocks(root) {
    (root || document).querySelectorAll('.faq-image').forEach(lockFaqImageMedia);
  }

  function openLightlabsWidget() {
    const widget = document.querySelector('lightlabs-widget');
    const openFn =
      (widget && typeof widget.openModal === 'function' && widget.openModal) ||
      (window.lightlabs && typeof window.lightlabs.openModal === 'function' && window.lightlabs.openModal);

    if (openFn) {
      openFn();
      return true;
    }

    const previewBtn = widget && widget.querySelector('button, .ll-content, [role="button"]');
    if (previewBtn) {
      previewBtn.click();
      return true;
    }

    return false;
  }

  function bindLightlabsLinks(section) {
    if (!section || section.dataset.faqImageLightlabsBound === 'true') return;

    section.dataset.faqImageLightlabsBound = 'true';
    section.addEventListener('click', (event) => {
      const lightlabsLink = event.target.closest('a[href="#lightlab-widget"]');
      if (!lightlabsLink || !section.contains(lightlabsLink)) return;

      event.preventDefault();
      if (openLightlabsWidget()) return;

      let attempts = 0;
      const timer = window.setInterval(() => {
        attempts += 1;
        if (openLightlabsWidget() || attempts >= 20) {
          window.clearInterval(timer);
        }
      }, 250);
    });
  }

  function initFaqImageLightlabs(root) {
    (root || document).querySelectorAll('.faq-image').forEach(bindLightlabsLinks);
  }

  if (!customElements.get('faq-image-reveal')) {
    class FaqImageReveal extends HTMLElement {
      constructor() {
        super();
        this.handleToggle = this.handleToggle.bind(this);
      }

      connectedCallback() {
        this.button = this.querySelector('.faq-image__toggle');
        this.extraItems = this.querySelector('.faq-image__extra');

        if (!this.button || !this.extraItems) return;

        this.extraItems.setAttribute('aria-hidden', 'true');
        this.extraItems.setAttribute('inert', '');
        this.button.addEventListener('click', this.handleToggle);
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.handleToggle);
      }

      handleToggle() {
        const isExpanded = this.button.getAttribute('aria-expanded') === 'true';
        const shouldExpand = !isExpanded;

        this.button.setAttribute('aria-expanded', shouldExpand.toString());
        this.extraItems.classList.toggle('faq-image__extra--expanded', shouldExpand);
        this.extraItems.setAttribute('aria-hidden', (!shouldExpand).toString());
        this.extraItems.toggleAttribute('inert', !shouldExpand);
      }
    }

    customElements.define('faq-image-reveal', FaqImageReveal);
  }

  initFaqImageMediaLocks();
  initFaqImageLightlabs();
  document.addEventListener('shopify:section:load', (event) => {
    initFaqImageMediaLocks(event.target);
    initFaqImageLightlabs(event.target);
  });
})();
